import select from 'dom-select';

export default {
  props: {
    name: String,
    label: String,
    modifier: {
      type: String,
      default: 'default',
    },
    placeholder: String,
    options_json: String,
    error: String,
    required: Boolean,
    validateMethod: Function,
  },
  data() {
    const data = {
      isActive: false,
      isValid: false,
      // selectedText: this.placeholder || '',
      selectedText: '',
      options: [],
      optionsObject: {},
      optionsHTML: '',
      showErrorMessage: false,
      id: null,
    };
    if (this.options_json) {
      try {
        data.options = JSON.parse(this.options_json);
      } catch (error) {
        data.options = [];
      }
    }
    if (this.placeholder) {
      data.optionsHTML +=
        '<option value="" disabled selected>' + this.placeholder + '</option>';
    }
    data.options.forEach((item) => {
      data.optionsHTML +=
        '<option value="' + item.value + '">' + item.label + '</option>';
      data.optionsObject[item.value] = item.label;
    });
    data.inputValue = '';
    return data;
  },
  watch: {
    inputValue() {
      this.isValid = true;
      this.updateOptionsValues();
      this.$emit('change', {
        value: this.inputValue,
        name: this.name,
      });
    },
  },
  mounted() {
    this.$emit('change', {
      value: this.inputValue,
      name: this.name,
    });
    if (this.inputValue) {
      this.setActive();
    }
    document.addEventListener('keypress', this.logKey);
    this.id = this._uid;
  },
  methods: {
    validateInput() {
      if (this.validateMethod) {
        const validation = this.validateMethod({
          value: this.inputValue,
          name: this.name,
        });
        this.isValid = validation.valid;
        this.errorMessage = validation.message;
      } else if (this.required && !this.inputValue) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
      return this.isValid;
    },
    setActive() {
      this.isActive = true;
    },
    unsetActive() {
      if (!this.inputValue) {
        this.isActive = false;
      }
      if (this.inputValue) {
        this.isValid = true;
      }
    },
    refresh() {
      setTimeout(() => {
        this.inputValue = this.$refs.input.value;
        if (this.inputValue) this.setActive();
      }, 0);
    },
    updateOptionsValues() {
      const iv = this.inputValue;
      this.options.forEach((item, index) => {
        if (item.value === iv) {
          this.options[index].isActive = true;
        } else {
          this.options[index].isActive = false;
        }
      });
    },
    logKey(e) {
      if (e.keyCode === 13) {
        const radioInput = select(
          '.radio-button__el .radio-button__label:focus .radio-button__input',
          this.$el,
        );
        if (radioInput) {
          this.$emit('change', {
            value: radioInput.value,
            name: select(
              '.radio-button__el .radio-button__label:focus span',
              this.$el,
            ).innerHTML,
          });
          this.inputValue = radioInput.value;
          if (this.inputValue) {
            this.setActive();
          }
        }
      }
    },
  },
  template: `
  <div
    class="radio-button"
    :class="['radio-button--'+modifier]">
      <div class="radio-button__wrapper">
        <fieldset>
          <legend v-if="label" class="radio-button__title">{{(label)}}</legend>
          <ul class="radio-button__el_list">
            <li v-for="(option, index) in options" class="radio-button__el" :key="option.value" :class="[(option.isActive)?'is-active': '']">
              <label role="radio" class="radio-button__label" tabindex="0" :for="'radio_' + id + '_' + index" :aria-checked="[(option.isActive)? true: false ]">
                <span>{{(option.label)}}</span>
                <div class="checkbox__icon"><span>&nbsp;</span></div>
                <input
                  :name="name"
                  @change="$emit('value-change')"
                  v-model="inputValue"
                  v-on:focus="setActive"
                  v-on:blur="unsetActive"
                  class="radio-button__input" type="radio" :value="option.value"
                  :id="'radio_' + id + '_' + index">
              </label>
            </li>
          </ul>
        </fieldset>
      </div>
      <p v-if="!isValid" class="radio-button__error form-row__error__text-error red">{{error}}</p>
  </div>`,
};
